const Theme = {
  body_background_color: '#006871',
  title_font: 'Roboto',
  text_font: 'Roboto',
  logo_image_url: 'mmv.jpg',
  token_url: 'mmv.png',
  number_hidden: true,
  token_margin_right: 10,
  header_full_height: true,
  header_no_margin: true,
  header_no_border: true,
  logo_full_width: true,
  button_border_width: 2,
  button_color: '#b21e15',
  button_hover_text_color: '#b21e15',
  button_radius: 20,
  button_outlined_border_color: '#b21e15',
  button_outlined_hover_border_color: '#b21e15'
}

export default Theme
